module.exports = __webpack_public_path__ + "images/emoji/no_mouth.dfbadff1c4e5bbd04b45.png";